import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, Users, CalendarDays, SlidersHorizontal, LogOut, ExternalLink, Activity } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/admin", end: true, label: "Overview", icon: LayoutGrid, id: "overview" },
  { to: "/admin/registrations", label: "Registrations", icon: Users, id: "registrations" },
  { to: "/admin/calendar", label: "Calendar", icon: CalendarDays, id: "calendar" },
  { to: "/admin/availability", label: "Availability", icon: SlidersHorizontal, id: "availability" },
  { to: "/admin/visitors", label: "Visitors", icon: Activity, id: "visitors" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const out = async () => {
    await logout();
    navigate("/admin/login");
  };
  const cls = ({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`;

  return (
    <div className="min-h-screen bg-[#F5F7FA] lg:flex" data-testid="admin-layout">
      <aside className="lg:w-64 lg:fixed lg:inset-y-0 bg-[#071426] text-white flex lg:flex-col px-4 py-3 lg:py-8 gap-2 overflow-x-auto">
        <div className="hidden lg:block px-3 mb-8">
          <span className="font-display text-xl font-bold tracking-[0.28em]">FAD</span>
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#C7A76C] mt-1">Admin</p>
        </div>
        <nav className="flex lg:flex-col gap-1 flex-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={cls} data-testid={`admin-nav-${l.id}`}>
              <l.icon size={16} /> <span className="whitespace-nowrap">{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="flex lg:flex-col gap-1 lg:border-t lg:border-white/10 lg:pt-4">
          <p className="hidden lg:block px-3 pb-2 text-xs text-white/40 truncate" data-testid="admin-user-email">{user?.email}</p>
          <a href="/" className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-white/60 hover:text-white" data-testid="admin-view-site-link"><ExternalLink size={16} /> <span className="hidden sm:inline">Website</span></a>
          <button onClick={out} className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-white/60 hover:text-white" data-testid="admin-logout-button"><LogOut size={16} /> <span className="hidden sm:inline">Log out</span></button>
        </div>
      </aside>
      <main className="flex-1 lg:ml-64 p-4 sm:p-8 lg:p-10 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
